module.exports = __webpack_public_path__ + "img/qrcode.5822be50.png";